import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import './theme/injectBrandVars';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import posthog from 'posthog-js';
import './api/axiosAuth';
import {PostHogProvider} from 'posthog-js/react'
import { appTheme } from './theme/muiTheme';
import { initOpenAIPixel } from './utils/openaiPixel';

initOpenAIPixel();

posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
  api_host: 'https://app.posthog.com',
  capture_pageview: false,
  autocapture: true,
  debug: false,
  // Group type `ta_org` is set via posthog.group() in utils/posthogAnalytics.js
  logs: {
    serviceName: 'twilanswer-frontend',
    environment: process.env.NODE_ENV || 'development',
    // Prefer structured posthog.logger over captureConsoleLogs to avoid
    // shipping tokens/PII from Twilio SDK / third-party console noise.
  },
});

// Keep analytics off across reloads during support impersonation.
if (typeof window !== 'undefined' && localStorage.getItem('twilanswer_impersonating') === '1') {
  posthog.opt_out_capturing();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={appTheme}>
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
